import { CaregiverDashboardView } from "@/features/caregiver/dashboard/components/CaregiverDashboardView";

export function CaregiverDashboardPage() {
  return <CaregiverDashboardView />;
}
